const gtmMap: { [x in typeof process.env.API_VER]: string } = {
    beta: 'GTM-WHXBBQH',
    production: 'GTM-K5JQPGL',
    stage: 'GTM-KC3463Z',
    'team-01': 'GTM-5M2GWLP',
    'team-02': 'GTM-WGMRF46',
    'team-03': 'GTM-PB25RKZ',
    'team-04': 'GTM-T7L9J8R',
    'team-05': 'GTM-KTKX5CR',
    'team-06': 'GTM-KTKX5CR',
    'team-07': 'GTM-KTKX5CR',
    'team-08': 'GTM-KTKX5CR',
    'team-09': 'GTM-KTKX5CR',
    'team-11': 'GTM-KTKX5CR',
};

export const gtmData = {
    id: gtmMap[process.env.API_VER],
};
